import React, { VoidFunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PasswordValidator,
  PasswordValidity
} from 'record-it-utils/password/PasswordValidator/PasswordValidator';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { Icon, IconSize, IconType } from '../Icon/Icon';
import { MessageBoxType } from '../MessageBox/MessageBox';
import {
  MessageListBox,
  MessageListBoxProps
} from '../MessageListBox/MessageListBox';
import { MessageListBoxListItem } from '../MessageListBoxListItem/MessageListBoxListItem';
import styles from './PasswordRulesBox.module.css';

export type PasswordRulesBoxProps = Omit<MessageListBoxProps, 'type'> & {
  passwordValidity: PasswordValidity;
};

export const PasswordRulesBox: VoidFunctionComponent<PasswordRulesBoxProps> =
  React.memo((props) => {
    const { passwordValidity, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { t } = useTranslation('record-it-components');

    return (
      <MessageListBox
        type={
          passwordValidity.valid ? MessageBoxType.Success : MessageBoxType.Error
        }
        {...remainingProps}
      >
        <MessageListBoxListItem
          className={classes(
            styles.passwordRule,
            passwordValidity.hasRequiredLength
              ? styles.passwordRuleValid
              : styles.passwordRuleInvalid
          )}
          data-testid="PassworRulesBox.RequiredLengthRule"
        >
          <Icon
            name={passwordValidity.hasRequiredLength ? 'check' : 'xmark'}
            type={IconType.Regular}
            size={IconSize.Small}
            className={styles.passwordRuleIcon}
          ></Icon>
          <span className={styles.passwordRuleText}>
            {t('misc.PasswordRulesBox.requiredLength', {
              requiredLength: PasswordValidator.REQUIRED_LENGTH
            })}
          </span>
        </MessageListBoxListItem>
      </MessageListBox>
    );
  });
